import { TransferAssetService } from './transfer-asset.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { TRANSFER_ASSET_TYPE, TransferAsset } from 'assets-model';
import { Observable } from 'rxjs';



@Injectable({ providedIn: 'root' })
export abstract class TransferAssetResolverBase implements Resolve<TransferAsset> {

  constructor(protected service: TransferAssetService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<TransferAsset> {
    const key: number = TRANSFER_ASSET_TYPE.entityDecorator.toKeyObjectFromRouteParams(route.params);
    return this.service.get(key);
  }
}



